import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#31344A",
      "fill-rule": "evenodd",
      "clip-path": "url(#i-1008348034__a)",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M2.357 12.572c.434 0 .786.351.786.785v1.572h8.643v-1.572a.786.786 0 0 1 1.571 0v7.072h5.5v-7.072a.786.786 0 0 1 1.572 0v7.072A1.571 1.571 0 0 1 18.857 22H3.143A1.571 1.571 0 0 1 1.57 20.43v-7.072c0-.434.352-.785.786-.785Zm.786 3.928v3.929h8.643V16.5H3.143ZM3.696 1.687a.786.786 0 0 1 .416-.116h13.776a.785.785 0 0 1 .707.431v.002l1.35 2.71H2.055l1.35-2.712a.786.786 0 0 1 .292-.315ZM0 5.5c0-.131.032-.255.09-.364L2 1.296A2.357 2.357 0 0 1 4.12 0h13.76A2.357 2.357 0 0 1 20 1.296L20 1.3l1.91 3.836A.782.782 0 0 1 22 5.5v3.143a1.571 1.571 0 0 1-1.571 1.571H1.57A1.572 1.572 0 0 1 0 8.643V5.5Zm20.429.786v2.357H1.57V6.286H20.43Z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-1008348034__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h22v22H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }